import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const LhsHeadingWrapper = styled(Box)(`
	width: 190px;
	display: flex;
    position: relative;
    padding-bottom: 10px;
    padding-right: 25px;
    &.level2 {
        position: absolute;
        left:0;
        top:0;
        width: 210px;
        .progressBar {
            width: 100%;
        }
    }
`)

export const TitlePercentWrapper = styled(Box)(`
	display: flex;
    font-size: 14px;
    width: calc(100% - 32px);
    line-height: 14px;
	& span {
		width: 100%;
		text-align: left;
	}
	& b {
		font-weight: 600;
        position: absolute;
        top: 0;
        right: 0;
	}
`)

export const ProgressBarWrapper = styled(Box)(`
	width: 100%;
    height: 5px;
	display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #F6F6F5;
	& span { height: 5px; display:inline-block;}
`)
